module.exports = __webpack_public_path__ + "assets/img/order.e83fee8d.svg";